import { useEffect, useState } from "react";
import { getBattle } from "../api/battleApi";

export function useBattleDetail(battleId) {
  const [battle, setBattle] = useState(null);
  const [joinCount, setJoinCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchDetail = async () => {
    if (!battleId) return;

    try {
      setLoading(true);
      const res = await getBattle(battleId);

      // 백엔드에서 내려주는 구조가 여기라고 했지
      // { battle: {...}, joinCount: 0 }
      setBattle(res.data.battle);
      setJoinCount(res.data.joinCount);
    } catch (e) {
      console.error("useBattleDetail error:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [battleId]);

  return { battle, joinCount, loading, reload: fetchDetail };
}
